import React from 'react';
import Styled from './styles/CertificadoPublic.styled';
import DynamicHeader from 'components/dynamic_header/DynamicHeader';
import { LiaCertificateSolid } from 'react-icons/lia';
import { YellowButton } from 'components/UI/Buttons';
import { CertificadoPublicHook } from './hooks/CerticadoPublicHook';
import ContactContainer from 'pages/home/components/contact/ContactContainer';
import Colors from 'enums/Colors';
import { MdArrowBackIos } from 'react-icons/md';
import { ModalCertificadoEnviarPorEmail } from './components/ModalCertificadoEnviarPorEmail';

const CertificadoPublic: React.FC = () => {
    const {
        certificados,
        page,
        setPage,
        handleClickCertificado,
        returnRoute,
        loadingIndex,
        handleAtualizarNomeUsuario,
        openModalAtualizarNome,
        setOpenModalAtualizarNome,
        nomeCompleto,
        loadingCertificado
    } = CertificadoPublicHook();

    const handleEmitirCertificado = async (certificacao: any, isEmited: boolean, index: number) => {
        await handleClickCertificado(certificacao, isEmited, index);
        // Aguarda um pouco para garantir que o usuário veja o loading
        await new Promise(resolve => setTimeout(resolve, 300));
        if (!isEmited) {
            setPage(2);
        }
    };

    return (
        <React.Fragment>
            <DynamicHeader />
            <Styled.Container>
                <Styled.Header>
                    {page != 0 && (
                        <Styled.BackButton onClick={returnRoute}>
                            <MdArrowBackIos /> Voltar
                        </Styled.BackButton>
                    )}
                    <Styled.Title>
                        Meus Certificados <LiaCertificateSolid />
                    </Styled.Title>
                    <Styled.Description>Acompanhe aqui os certificados disponíveis dos cursos realizados por você.</Styled.Description>
                </Styled.Header>
            </Styled.Container>
            {page == 0 && (
                <Styled.Content>
                    <Styled.SubTitle>O que você desejar fazer?</Styled.SubTitle>
                    <Styled.Row>
                        <YellowButton
                            onClick={() => setPage(2)}
                            style={{
                                borderRadius: '4px',
                                maxHeight: '61px',
                                height: '61px',
                                fontSize: '18px',
                                maxWidth: '500px',
                                textTransform: 'uppercase',
                                lineHeight: '24px',
                            }}
                        >
                            Ver Certificados Emitidos
                        </YellowButton>
                        <YellowButton
                            onClick={() => setPage(1)}
                            style={{
                                borderRadius: '4px',
                                maxHeight: '61px',
                                height: '61px',
                                fontSize: '18px',
                                maxWidth: '500px',
                                textTransform: 'uppercase',
                                lineHeight: '24px',
                                backgroundColor: Colors.Blue,
                                color: Colors.White,
                            }}
                        >
                            ver certificados Disponíveis para emissão
                        </YellowButton>
                    </Styled.Row>
                </Styled.Content>
            )}
            {page == 1 && (
                <Styled.Content>
                    <Styled.SubTitle>Certificados Disponíveis</Styled.SubTitle>
                    {certificados.length == 0 || certificados.every(certificado => certificado.emited) ? (
                        <Styled.Description>Você não possui certificados disponíveis para emissão no momento.</Styled.Description>
                    ) : (
                        <>
                            <Styled.ContentGrid>
                                {certificados
                                    .filter(ct => !ct.emited)
                                    .map((certificado, index) => (
                                        <Styled.Card key={certificado.codigo}>
                                            <p
                                                dangerouslySetInnerHTML={{
                                                    __html: `
                                <strong>Certificado:</strong><br/>
                                ${certificado.certificacao.nome}<br/><br/> 
                            `,
                                                }}
                                            />
                                            {!certificado.certificacao.precisaSolicitar && (
                                                <div style={{ display: 'flex', gap: '2rem' }}>
                                                    <YellowButton
                                                        onClick={() => handleEmitirCertificado(certificado.certificacao, false, index)}
                                                        disabled={loadingIndex !== null}
                                                        style={{
                                                            borderRadius: '4px',
                                                            width: '240px',
                                                            maxHeight: '60px',
                                                            backgroundColor: Colors.Blue,
                                                            textTransform: 'uppercase',
                                                            lineHeight: '24px',
                                                            color: Colors.White,
                                                            opacity: loadingIndex === index ? 0.6 : 1,
                                                            cursor: loadingIndex === index ? 'not-allowed' : 'pointer',
                                                        }}
                                                    >
                                                        {loadingIndex === index ? 'Carregando...' : 'Emitir Certificado'}
                                                    </YellowButton>
                                                    {certificado.certificacao.certificateTemplateInternal && (
                                                        <ModalCertificadoEnviarPorEmail
                                                            codigoCertificado={certificado.certificacao.codigo ?? -1}
                                                        />
                                                    )}
                                                </div>
                                            )}
                                        </Styled.Card>
                                    ))}
                            </Styled.ContentGrid>
                        </>
                    )}
                </Styled.Content>
            )}
            {page == 2 && (
                <Styled.Content>
                    <Styled.SubTitle>Certificados Emitidos</Styled.SubTitle>
                    {certificados.length == 0 || certificados.every(certificado => !certificado.emited) ? (
                        <Styled.Description style={{ fontSize: '22px' }}>
                            Você ainda não possui certificados emitidos. Quando emitir um certificado, ele aparecerá aqui.
                        </Styled.Description>
                    ) : (
                        <>
                            <Styled.ContentGrid>
                                {certificados
                                    .filter(ct => ct.emited)
                                    .map((certificado, index) => (
                                        <Styled.Card key={certificado.codigo}>
                                            <p
                                                dangerouslySetInnerHTML={{
                                                    __html: `
                                <strong>Certificado:</strong><br/>
                                ${certificado.certificacao.nome}<br/><br/> 
                                <strong>Emitido em:</strong><br/>
                                ${new Date(certificado.dataCreate).toLocaleDateString('pt-BR')}<br/><br/>
                            `,
                                                }}
                                            />
                                            <div style={{ display: 'flex', gap: '2rem' }}>
                                                <YellowButton
                                                    onClick={() => handleClickCertificado(certificado.certificacao, true, index)}
                                                    disabled={loadingIndex === index}
                                                    style={{
                                                        borderRadius: '4px',
                                                        width: '240px',
                                                        maxHeight: '60px',
                                                        textTransform: 'uppercase',
                                                        lineHeight: '24px',
                                                        opacity: loadingIndex === index ? 0.6 : 1,
                                                        cursor: loadingIndex === index ? 'not-allowed' : 'pointer',
                                                    }}
                                                >
                                                    {loadingIndex === index ? 'Carregando...' : 'Emitir a 2ª via'}
                                                </YellowButton>
                                                {!certificado.certificacao.precisaSolicitar &&
                                                    certificado.certificacao.certificateTemplateInternal && (
                                                        <ModalCertificadoEnviarPorEmail
                                                            codigoCertificado={certificado.certificacao.codigo ?? -1}
                                                        />
                                                    )}
                                            </div>
                                        </Styled.Card>
                                    ))}
                            </Styled.ContentGrid>
                        </>
                    )}
                </Styled.Content>
            )}
            <ContactContainer />
        </React.Fragment>
    );
};

export default CertificadoPublic;
